module.exports = __webpack_public_path__ + "static/sinaloa-0dc2f11481dbbb70a36a6fde78884cc1.png";